import Customer from './customer';
import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';
import { OrderStatus } from '../types';
import { LocalDate } from '../utils/local-date';

import type SiteMenuBeverageOrder from './site-menu-beverage-order';
import type SiteMenuOrder from './site-menu-order';
import type SiteMenuSupplyOrder from './site-menu-supply-order';

@JsonApiResource({
  type: 'archived-customer-order',
})
export default class ArchivedCustomerOrder extends BaseEntity {
  @JsonApiProperty({ resolver: (val: any) => new LocalDate(val) }) orderDate = new LocalDate().add(
    2,
    'day'
  );

  @JsonApiProperty({ type: 'boolean', readOnly: true }) isEditable: boolean = false;
  @JsonApiProperty({ type: 'boolean', readOnly: true }) isCancellable: boolean = false;

  status: OrderStatus = OrderStatus.Submitted;
  siteNames?: string;
  siteNamesWithDisplayNumber?: string;
  originalCreatedBy?: string;

  @JsonApiRelationship('customer') customer = new Customer();
  @JsonApiRelationship('site-menu-order') siteMenuOrders: SiteMenuOrder[] = [];
  @JsonApiRelationship('site-menu-beverage-order') siteMenuBeverageOrders: SiteMenuBeverageOrder[] =
    [];

  @JsonApiRelationship('site-menu-supply-order') siteMenuSupplyOrders: SiteMenuSupplyOrder[] = [];
}
